import { Button, Card, CardContent, Chip, Grid, IconButton, makeStyles, Tab, Tabs, Typography } from '@material-ui/core'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getDiasTurnosDisponibles, getHorasTurnosDisponibles, getTurnosDisponibles, limpiarDatosDeTurnosParametrosAnteriores, seleccionarTurno } from '../../../actions/webAfiliado/afiliadoTurnosAction';
import LoadingBeforeViewData from '../../compartidos/LoadingBeforeViewData';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { capitalize } from '../../../helpers/randoms';

const useStyles = makeStyles((theme) => ({
    buttons: {
        marginTop: "2rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-around"
    },
    container: {
        backgroundColor: "#fff", marginTop: "1rem"
    },
    cardPrimary: {
        marginTop: "1rem",
        borderColor: theme.palette.primary.main
    },
    cardError: {
        marginTop: "1rem",
        borderColor: theme.palette.error.main
    },
    titleCard: {
        display: "block"
    },
    itemCard: {
        fontWeight: "bold"
    },
    sinResultados: {
        fontWeight: "bold"
    },
    chips: {
        marginTop: 5
    },
    containerChips: {
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
        marginBottom: "1rem"
    }
}));

const SacarTurnoPaso3 = (props) => {
    const { idAfiliado, diasDisponibles, horasDisponibles, turnosDisponibles, idCentroMedico, idProfesional, idEspecialidad, virtual } = props

    const classes = useStyles()
    const dispatch = useDispatch()

    const { credenciales } = useSelector(state => state.afiliadoVarios)

    const fechaFinCobertura = credenciales?.find(e => e.idAfiliado === idAfiliado)?.fechaFinCobertura
    
    const [dia, setDia] = useState(0)
    const handleChangeDia = (isBack = false) => {
        setTurnoDisponible(null)
        if (isBack) {
            if (dia > 0) {
                setDia(dia - 1)
                if (idProfesional !== null) {
                    dispatch(getTurnosDisponibles(idEspecialidad, idCentroMedico, idProfesional, virtual, diasDisponibles[dia - 1], null))
                } else {
                    dispatch(getHorasTurnosDisponibles(idEspecialidad, idCentroMedico, virtual, diasDisponibles[dia - 1]))
                }
            }
        } else {
            if (dia < diasDisponibles.length - 1) {
                setDia(dia + 1)
                if (idProfesional !== null && idProfesional !== "") {
                    dispatch(getTurnosDisponibles(idEspecialidad, idCentroMedico, idProfesional, virtual, diasDisponibles[dia + 1], null))
                } else {
                    dispatch(getHorasTurnosDisponibles(idEspecialidad, idCentroMedico, virtual, diasDisponibles[dia + 1]))
                }
            }
        }
    }

    const [hora, setHora] = useState(null)
    const handleSelectHora = (item) => {
        setHora(item)
        dispatch(getTurnosDisponibles(idEspecialidad, idCentroMedico, null, virtual, diasDisponibles[dia], item))
    }

    const [tab, setTab] = useState(1) // 1=Presencial 2=Virtual
    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    const [turnoDisponible, setTurnoDisponible] = useState(null)
    const handleSelectTurnoDisponible = (item) => {
        setTurnoDisponible(item)
        dispatch(seleccionarTurno({ ...item, idTipoTurno: tab }))
    }

    useEffect(() => {
        if (idAfiliado !== "") {
            dispatch(getDiasTurnosDisponibles(idEspecialidad, idCentroMedico, idProfesional, virtual))
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (turnosDisponibles?.filter(e => e.idTipoTurno === 1 || e.idTipoTurno === 3).length === 0 && virtual) {
            setTab(2)
        } else {
            setTab(1)
        }
        // eslint-disable-next-line
    }, [turnosDisponibles])

    //Fijarse las horas
    if (diasDisponibles === null) {
        return <LoadingBeforeViewData />
    }

    if (idProfesional === null || idProfesional === "") {
        if (diasDisponibles.length > 0 && horasDisponibles === null) {
            return <LoadingBeforeViewData />
        }
    } else {
        if (diasDisponibles.length > 0 && turnosDisponibles === null) {
            return <LoadingBeforeViewData />
        }
    }

    return (
        <Grid container className={classes.container}>
            {
                diasDisponibles.length === 0
                    ?
                    <>
                        <Grid item xs={null} sm={null} md={3} />
                        <Grid item xs={12} md={6}>
                            <Card className={classes.cardError} variant="outlined">
                                <CardContent>
                                    <Typography color="error" align="justify">No hay un turno disponible con los parámetros especificados. Cambielos y vuelta a intentar.</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={null} sm={null} md={3} />
                    </>
                    :
                    <>
                        {
                            virtual &&
                            <>
                                <Grid item xs={null} sm={null} md={2} />
                                <Grid item xs={12} md={8}>
                                    <Tabs
                                        value={tab}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={handleChange}
                                        variant="fullWidth"
                                        style={{ marginBottom: "1rem" }}
                                    >
                                        {/* <Tab label="Presencial" value={1} />
                                        <Tab label="Teleconsulta" value={2} /> */}

                                        {
                                            turnosDisponibles?.filter(e => e.idTipoTurno === 1 || e.idTipoTurno === 3).length > 0 &&
                                            <Tab label="Presencial" value={1} />
                                        }
                                        {
                                            (turnosDisponibles?.filter(e => e.idTipoTurno === 2 || e.idTipoTurno === 3).length > 0) &&
                                            <Tab label="Teleconsulta" value={2} />
                                        }
                                    </Tabs>
                                </Grid>
                                <Grid item xs={null} sm={null} md={2} />
                            </>
                        }
                        <Grid item xs={null} sm={null} md={2} />
                        <Grid item xs={12} md={8}>
                            <Grid container style={{ marginTop: "1rem" }}>
                                <Grid item xs={3} style={{ textAlign: "center" }}>
                                    <IconButton onClick={() => handleChangeDia(true)}>
                                        <ChevronLeftIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={6} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Typography align="center">{`${capitalize(moment(diasDisponibles[dia]).format("dddd DD"))} de ${moment(diasDisponibles[dia]).format("MMMM")}`}</Typography>
                                </Grid>
                                <Grid item xs={3} style={{ textAlign: "center" }}>
                                    <IconButton onClick={() => handleChangeDia()}>
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>

                            {
                                (fechaFinCobertura === null || moment(diasDisponibles[dia]).isSameOrBefore(moment(fechaFinCobertura)))
                                    ?
                                    <>
                                        <Typography align="center" style={{ marginTop: "1rem" }}>Seleccioná un horario</Typography>
                                        {
                                            (idProfesional === null || idProfesional === "") &&
                                            <div className={classes.containerChips}>
                                                {
                                                    horasDisponibles.map((e, index) => {
                                                        return (
                                                            <Chip color="primary" key={e} variant={hora === e ? "default" : "outlined"} className={classes.chips} label={e} onClick={() => handleSelectHora(e)} />
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            ((idProfesional !== null && idProfesional !== "") || (turnosDisponibles !== null && hora !== null)) &&
                                            <>
                                                {
                                                    (idProfesional === null || idProfesional === "") &&
                                                    <Typography align="center" style={{ marginTop: "1rem" }}>Seleccioná una/un profesional</Typography>
                                                }

                                                <div className={classes.containerChips}>

                                                    {
                                                        tab === 1 &&
                                                        (
                                                            turnosDisponibles.filter(e => e.idTipoTurno === 1 || e.idTipoTurno === 3).length === 0
                                                                ?
                                                                <Typography className={classes.sinResultados}>Sin Turnos</Typography>
                                                                :
                                                                // eslint-disable-next-line
                                                                turnosDisponibles.map((e, index) => {
                                                                    if (e.idTipoTurno === 1 || e.idTipoTurno === 3) {
                                                                        return (
                                                                            <Chip key={e.idAgenda} color="primary" variant={turnoDisponible?.idAgenda === e.idAgenda ? "default" : "outlined"} className={classes.chips} label={idProfesional === null ? e.efectorRed.nombreEfector : e.hora} onClick={() => handleSelectTurnoDisponible(e)} />
                                                                        )
                                                                    }
                                                                })
                                                        )
                                                    }

                                                    {
                                                        tab === 2 &&
                                                        (
                                                            turnosDisponibles.filter(e => e.idTipoTurno === 2 || e.idTipoTurno === 3).length === 0
                                                                ?
                                                                <Typography className={classes.sinResultados}>Sin Turnos</Typography>
                                                                :
                                                                // eslint-disable-next-line
                                                                turnosDisponibles.map((e, index) => {
                                                                    if (e.idTipoTurno === 2 || e.idTipoTurno === 3) {
                                                                        return (
                                                                            <Chip key={e.idAgenda} color="primary" variant={turnoDisponible?.idAgenda === e.idAgenda ? "default" : "outlined"} className={classes.chips} label={idProfesional === null ? e.efectorRed.nombreEfector : e.hora} onClick={() => handleSelectTurnoDisponible(e)} />
                                                                        )
                                                                    }
                                                                })
                                                        )
                                                    }
                                                    {
                                                        turnosDisponibles.length === 0 &&
                                                        <Typography className={classes.sinResultados}>Sin Turnos</Typography>
                                                    }
                                                </div>
                                            </>
                                        }
                                    </>
                                    :
                                    <Card className={classes.cardError} variant="outlined">
                                        <CardContent>
                                            <Typography color="error" align="center">Beneficiario/a con cobertura inactiva  para la fecha seleccionada</Typography>
                                        </CardContent>
                                    </Card>
                            }
                        </Grid>
                        <Grid item xs={null} sm={null} md={2} />
                    </>
            }
            <Grid item xs={null} sm={null} md={2} />
            <Grid item xs={12} md={8}>
                <div className={classes.buttons}>
                    <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        style={{ textTransform: "none" }}
                        onClick={() => {
                            props.setearVariosValores({
                                idEspecialidad: null,
                                idCentroMedico: null,
                                idProfesional: null,
                                virtual: false,
                                primero: false
                            })
                            dispatch(limpiarDatosDeTurnosParametrosAnteriores())
                            props.handleChangeStep(1)
                        }}
                    >
                        Anterior
                    </Button>
                    {
                        turnoDisponible &&
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            style={{ textTransform: "none" }}
                            onClick={() => {
                                props.handleChangeStep(3)
                            }}
                        >
                            Siguiente
                        </Button>
                    }
                </div>
            </Grid>
            <Grid item xs={null} sm={null} md={2} />
        </Grid>
    )
}

export default SacarTurnoPaso3